import { Box, Container, Stack } from "@mui/system";
import { useEffect, useRef } from "react";
import "./Carousel.css";

import logo1 from "assets/home-brands-logos/logo1.png";
import logo2 from "assets/home-brands-logos/logo2.png";
import logo3 from "assets/home-brands-logos/logo3.png";
import logo4 from "assets/home-brands-logos/logo4.png";
import logo5 from "assets/home-brands-logos/logo5.svg";
import logo6 from "assets/home-brands-logos/logo666.webp";
import logo7 from "assets/home-brands-logos/logo777.png";
import logo8 from "assets/home-brands-logos/logo8.svg";
import logo9 from "assets/home-brands-logos/logo999.webp";

const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9];

const Carousel = ({
  items = [],
  activeIndex = 0,
  onSelect = () => {},
  isRTL = false,
}) => {
  const logosScrollerRef = useRef(null);
  const itemRefs = useRef([]);

  // In RTL, we render items in reverse order visually,
  // so we need to map activeIndex to the reversed position
  const displayItems = isRTL ? [...items].reverse() : items;
  const displayIndex = isRTL ? items.length - 1 - activeIndex : activeIndex;

  const scrollLogoToCenter = (index, behavior = "auto") => {
    if (!itemRefs.current[index] || !logosScrollerRef.current) return;

    const carousel = logosScrollerRef.current;
    const item = itemRefs.current[index];
    const carouselWidth = carousel.offsetWidth;
    const maxScrollLeft = carousel.scrollWidth - carouselWidth;

    let scrollPosition =
      item.offsetLeft - carouselWidth / 2 + item.offsetWidth / 2;
    scrollPosition = Math.max(0, Math.min(scrollPosition, maxScrollLeft));

    carousel.scrollTo({ left: scrollPosition, behavior });
  };

  useEffect(() => {
    if (!items.length) return;
    scrollLogoToCenter(displayIndex, "smooth");
  }, [activeIndex, items.length, isRTL]);

  return (
    <div className="carousel-container" dir={isRTL ? "rtl" : "ltr"}>
      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          margin: 0,
          height: { xs: "auto", md: "auto" },
          pb: { xs: 2, md: 0 },
          px: { xs: 0, md: "16px" },
        }}
      >
        <Stack
          direction="row"
          spacing={5}
          justifyContent="center"
          alignItems="center"
          sx={{ width: "100%" }}
        >
          <Box sx={{ width: "100%" }}>
            <div className="carousel">
              <div className="carousel-track-line" />
              {/* Always direction: ltr so offsetLeft and scrollTo are predictable */}
              <div
                className="carousel-logos"
                ref={logosScrollerRef}
              >
                {displayItems.map((item, index) => {
                  const isActive = index === displayIndex;
                  // Map display index back to original index for onSelect
                  const originalIndex = isRTL ? items.length - 1 - index : index;
                  return (
                    <div
                      key={item.key}
                      ref={(el) => (itemRefs.current[index] = el)}
                      className={`carousel-item ${isActive ? "active" : ""}`}
                      onClick={() => onSelect(originalIndex)}
                    >
                      <img src={logos[originalIndex]} alt={item.key} />
                    </div>
                  );
                })}
              </div>
            </div>
          </Box>
        </Stack>
      </Container>
    </div>
  );
};


export default Carousel;